import { AppSetting } from '../AppSetting';
import { BaseWebApiDAO } from './BaseWebApiDAO';
import { BaseService } from '../Service/BaseService';
import { AppSettingApi } from '../AppSettingApi';



/**
 * GuestUserDAO
 * 認証系DAO
 */
export class GuestUserDAO extends BaseWebApiDAO {

	// コンストラクタ
	constructor(svc: BaseService) {
		super(svc);
	}


	public async registerGuestUser(email: string, confirm: string, identifier: string) {

		const request = {
			identifier,
			email,
			confirm,
		};


		const ret = await this.postRequest(AppSettingApi.GUEST_USER_REGISTER, request);
		return ret;
	}


	/**
	 * getGuestUserInfo
	 * ゲストユーザー情報の取得
	 * @returns ゲストユーザー情報
	 */
	public async getGuestUserInfo(registKey: string) {

		// デバッグモードならダミーを返す
		if ( AppSetting.DEBUG_MODE_DUMYDATA ) {
			return;
		}

		const request = {
			t: this.token,
			key: registKey
		};

		const ret = await this.postRequest(AppSettingApi.GUEST_USER_INFO_GET, request);
		return ret;

	}

	/**
	 * ゲストコードの再送信要求
	 * 正しければゲスト情報が取得される。失敗すればnull
	 * @param id
	 */
	public async resendGuestCode(id: number) {
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return;
		}

		const request = {
			id
		};

		return await this.postRequest(AppSettingApi.GUEST_USER_CODE_RESEND, request);
	}

	/**
	 * ゲストコードの成否チェック
	 * 正しければゲスト情報が取得される。失敗すればnull
	 * @param id
	 * @param code
	 */
	public async checkGuestCode(id: number, code: string) {
		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return;
		}

		const request = {
			id,
			code
		};

		return await this.postRequest(AppSettingApi.GUEST_USER_CHECK, request);
	}

}

